var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalendarPaid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.5H16.5V2H15V3.5H9V2H7.5V3.5H4.5C3.68 3.5 3 4.18 3 5V20C3 20.83 3.68 21.5 4.5 21.5H19.5C20.33 21.5 21 20.83 21 20V5C21 4.18 20.33 3.5 19.5 3.5ZM19.5 20H4.5V9.5H19.5V20ZM19.5 8H4.5V5H7.5V6.5H9V5H15V6.5H16.5V5H19.5V8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.5H12.75C12.3358 12.5 12 12.8358 12 13.25V17.75C12 18.1642 12.3358 18.5 12.75 18.5H17.25C17.6642 18.5 18 18.1642 18 17.75V13.25C18 12.8358 17.6642 12.5 17.25 12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarPaid);
export default __webpack_public_path__ + "static/media/ic-calendar-paid.0bec3a89323e6069ad1576d3057ace23.svg";
export { ForwardRef as ReactComponent };